


























































































import { Component, Ref, Vue } from 'vue-property-decorator'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import { ProdutoDaImportacao } from '@/models/ImportacaoDeNota'
import Confirmacao from '@/components/ui/Confirmacao.vue'

@Component({
	components: {
		Confirmacao,
	},
})
export default class DialogoDeAgruparItensDaImportacao extends Vue {
	@Ref() confirmacaoDeAgruparItens!: Confirmacao
	@Ref() confirmacaoDeDesagruparItens!: Confirmacao

	mostra = false
	selecionados: ProdutoDaImportacao[] = []
	indiceDoItemARelacionar = 0
	itemBaseAgrupamento: ProdutoDaImportacao | null = null
	itensParaAgrupar: ProdutoDaImportacao[] = []
	searchTerm = '' 
	isDesagrupamento = false

	headers = [
		{ text: 'Nome', value: 'nota.xProd', sortable: false },
		{ text: 'Quantidade', value: 'nota.qCom', sortable: false },
		{ text: 'Cód Fornecedor', value: 'nota.cProd', sortable: false },
		{ text: 'EAN', value: 'nota.cEAN',sortable: false },
	]

	mostrar(item: ProdutoDaImportacao, produtosParaAgrupar: ProdutoDaImportacao[]){
		this.mostra = true
		this.itemBaseAgrupamento = item
		produtosParaAgrupar = produtosParaAgrupar.filter(p => p.nota.nItem !== item.nota.nItem)
		this.itensParaAgrupar = produtosParaAgrupar
		const ncmBase = this.itemBaseAgrupamento.nota.NCM;

		this.itensParaAgrupar = this.itensParaAgrupar.filter(item => item.nota.NCM === ncmBase);
	}

	mostrarDesagrupamento(item: ProdutoDaImportacao, produtosParaAgrupar: ProdutoDaImportacao[]){
		this.mostra = true
		this.isDesagrupamento = true
		this.itemBaseAgrupamento = item
		this.itensParaAgrupar = produtosParaAgrupar
	}

	esconder(){
		this.mostra = false
		this.selecionados = []
		this.searchTerm = ''
		this.isDesagrupamento = false
		this.itemBaseAgrupamento = null
		this.itensParaAgrupar = []
	}

	get modoNoturno(){
		return AppStore.modoNoturno
	}

	async salvarAgrupamento(){
		const vincularProduto = !!(await this.confirmacaoDeAgruparItens.mostrar());

		if(vincularProduto){
			const quantidadesSomadas =
			this.selecionados.reduce((total, p) => total + Number(p.nota.qCom || 0), 0)
		
			const idsParaRemover = Array.from(
				new Set([this.selecionados, ...this.selecionados.map(p => p.nota.nItem)]),
			)

			this.$emit('quantidadeAgrupada', (quantidadesSomadas + Number(this.itemBaseAgrupamento?.nota.qCom || 0)), this.itemBaseAgrupamento?.indice, idsParaRemover, this.selecionados)
			this.esconder()
		}
	}

	async salvarDesagrupamento(){
		const desagruparProduto = !!(await this.confirmacaoDeDesagruparItens.mostrar());

		if(desagruparProduto){
			const quantidadesSomadas =
			this.selecionados.reduce((total, p) => total + Number(p.nota.qCom || 0), 0)

			this.$emit('desagrupar', this.selecionados, this.itemBaseAgrupamento?.indice, (Number(this.itemBaseAgrupamento?.nota.qCom) - quantidadesSomadas))
			this.esconder()
		}
	}

	formatarMensagemDeAgrupamentoProdutos(){
		return `
			<div><h2 class="formatarAviso">Aviso!</h2></div>
			<div class="mt-4">
				Ao confirmar, todas as alterações feitas apenas nos produtos que serão agrupados serão perdidas.
				O item principal continuará conforme alterações
			</div>
		`
	}

	formatarMensagemDeDesagrupamentoDeProdutos(){
		return `
			<div><h2 class="formatarAviso">Aviso!</h2></div>
			<div class="mt-4">
				Se confirmar, os itens serão retornados conforme sua versão anterior, o item principal não será afetado!
			</div>
		`
	}

	get filteredItens() {
		if (!this.itensParaAgrupar) return []

		const itens = this.isDesagrupamento ? 
			this.itensParaAgrupar : 
			this.itensParaAgrupar.filter(p => !p.isCamposBloqueados && !p.isProdutoEstaAgrupado)

		if (!this.searchTerm) return itens

		const q = this.searchTerm.toString().trim().toLowerCase()

		return itens.filter(i => {
			const nome = (i.nota.xProd || '').toString().toLowerCase()
			const cod = (i.nota.cProd || '').toString().toLowerCase()
			return nome.includes(q) || cod.includes(q)
		})
	}

}
